var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullInstagram = function SvgFullInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 1,
    y: 1,
    fill: "url(#FullInstagram_svg__a)",
    rx: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 1,
    y: 1,
    fill: "url(#FullInstagram_svg__b)",
    rx: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 4.375c-1.527 0-1.719.007-2.319.034s-1.007.122-1.365.261c-.37.144-.684.336-.997.649a2.8 2.8 0 0 0-.649.996c-.14.358-.234.767-.261 1.366s-.034.791-.034 2.319.007 1.719.034 2.319.122 1.007.261 1.365c.144.37.336.684.649.997s.626.505.996.649c.358.139.767.234 1.366.261s.791.034 2.319.034 1.719-.007 2.319-.034 1.008-.122 1.366-.261c.37-.144.683-.337.995-.65.313-.312.505-.626.65-.996.138-.358.233-.766.261-1.365.027-.6.034-.791.034-2.319s-.007-1.72-.034-2.32c-.028-.598-.123-1.007-.261-1.365a2.8 2.8 0 0 0-.65-.996 2.75 2.75 0 0 0-.996-.649c-.358-.139-.767-.234-1.366-.261s-.791-.034-2.32-.034zm-.504 1.014H10c1.501 0 1.68.005 2.273.032.548.025.846.117 1.044.194.262.102.45.224.646.42.197.197.319.385.421.647.077.198.169.496.194 1.044.027.593.033.772.033 2.273 0 1.5-.006 1.679-.033 2.272-.025.548-.117.846-.194 1.044a1.74 1.74 0 0 1-.42.646 1.74 1.74 0 0 1-.647.421c-.198.077-.496.169-1.044.194-.593.027-.772.033-2.273.033s-1.68-.006-2.273-.033c-.549-.026-.847-.117-1.045-.194a1.74 1.74 0 0 1-.647-.42 1.74 1.74 0 0 1-.42-.647c-.078-.198-.17-.496-.195-1.044-.026-.594-.032-.772-.032-2.274s.006-1.679.032-2.272c.026-.548.117-.846.194-1.044.102-.263.224-.45.421-.647s.385-.319.647-.421c.198-.077.496-.169 1.045-.194.518-.024.72-.03 1.768-.032zm3.507.934a.675.675 0 1 0 0 1.35.675.675 0 0 0 0-1.35m-3.002.788a2.889 2.889 0 1 0 0 5.778 2.889 2.889 0 0 0 0-5.778m0 1.014a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "FullInstagram_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -17.8393 16.592 0 5.781 20.386)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "FullInstagram_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(78.681 -2.408 -.08)scale(7.97428 32.8702)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F",
    stopOpacity: 0
  })))));
};
export default SvgFullInstagram;